<template>
    <div>
        <p>{{question.number}}. {{question.title}}</p>
        <p>
            <input type="text" disabled/>
        </p>
        <p v-if="question.dependentQuestion" class="question-info">
            Pytanie zależne od pytania: {{question.dependentQuestion.number}}. {{question.dependentQuestion.title}}
        </p>
    </div>
</template>


<script>

    export default {
        props: ['question'],
        emits: [],
        components: {},

    }
</script>